import { render } from "./OrderModalImport.vue?vue&type=template&id=2377ea97"
import script from "./OrderModalImport.vue?vue&type=script&lang=js"
export * from "./OrderModalImport.vue?vue&type=script&lang=js"

import "./OrderModalImport.vue?vue&type=style&index=0&id=2377ea97&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__